export default __webpack_public_path__ + "static/media/g4.1daef8c7.jpg";